export const dashboard=[
    {
        name:'dashboardName',
        path: 'dashboard',
        component: () => import('@/views/dashboard/index.vue')
    }
]
